import React, {useEffect, useState} from 'react';
import './Status.css';
import axios from "axios";

const Status = () => {
  const [pass, setPass] = useState({});
  useEffect(() => {
    const fetchPastPasses = async () => {
      try {
        const headers = {
          'Authorization': localStorage.getItem("token"),
          'Content-Type': 'application/json',
        };
        const data = await axios.get(`${process.env.REACT_APP_API_URL}api/v1/student/status`,{headers});
        console.log(data)
        setPass(data.data);
      } catch (error) {
        console.error('Error fetching accepted passes:', error);
      }
    };

    fetchPastPasses()
  }, []); // Empty dependency array to ensure the effect runs only once

  return (
      <div className="status-container">
        <div className="status-details">
          <div className="detail">
              <span className="label">Name:</span>
              <span className="value">{pass.name}</span>
          </div>
          <div className="detail">
            <span className="label">Enrollment No.:</span>
            <span className="value">{pass.rollNo}</span>
          </div>
          <div className="detail">
            <span className="label">Proceeding to:</span>
            <span className="value">{pass.where}</span>
          </div>
          <div className="detail">
            <span className="label">Current Semester:</span>
            <span className="value">{pass.sem}</span>
          </div>
          <div className="detail">
            <span className="label">Transport:</span>
            <span className="value">{pass.transport}</span>
          </div>
          <div className="detail">
            <span className="label">Purpose:</span>
            <span className="value">{pass.purpose}</span>
          </div>
          <div className="detail">
            <span className="label">Time:</span>
            <span className="value">{pass.outTime}</span>
          </div>
          <div className="detail">
            <span className="label">Date:</span>
            <span className="value">{pass.date}</span>
          </div>
        </div>
        {
          pass.status === "APPROVED" || pass.status === "VERIFIED" ?
            <button className="status-button status-accepted"> 
              {pass.status}
            </button> 
          : 
          (
            pass.status==="REJECTED" ? 
              <><button className="status-button status-rejected"> 
                {pass.status}  
              </button> <br />
              {pass.rejectReason}</>
            :
              <button className="status-button status-pending">
                {pass.status? pass.status:"N/A"}
              </button>
          )
        }
      </div>
  );
};

export default Status;
